module.exports = __webpack_public_path__ + "img/404.df9828e2.svg";